/* ==========================================================================
  Main.js
========================================================================== */

(function ($) {

  // headroom
  const header = document.querySelector("#masthead");
  if (header) {
    const headroom = new Headroom(header, {
      offset: 100,
      tolerance: {
        up: 10,
        down: 10,
      },
    });
    headroom.init();
  }

  // Mobile navigation
  $(document).ready(function () {
    $("#header-mobile-menu").aucor_side_navigation({
      menu_toggle: "#menu-toggle", // selector for toggle
      menu_items: isannointiliitto_menu,
    });
  });

  // Aucor navigation
  //$(document).ready(function(){
  //  $('#site-navigation').aucor_navigation({
  //    desktop_min_width: 501, // min width in pixels
  //    menu_toggle: "#menu-toggle" // selector for toggle
  //  });
  //});

  // Responsive videos
  $(document).ready(function () {
    $("body").fitVids();
  });

  // Notification window
  function notification_resize() {
    var $modal = $(".notification-content");

    if ($modal && !$modal.hasClass("notification-content--no-resize")) {
      var window_height = $(window).height();
      var content_height = $(".notification-content").height();
      var margin = (window_height - content_height) / 2 - 40;
      if (margin < 20) {
        margin = 20;
      }
      $(".notification-content").css("margin-top", margin + "px");
    }
  }
  $(window).resize(function () {
    notification_resize();
  });
  $(window).load(function () {
    notification_resize();
  });
  notification_resize();

  $(".js-notification-dismiss").click(function (e) {
    $(".notification-overlay").toggleClass("notification-overlay--active");
    notification_resize();
    e.preventDefault();
  });
  $(".js-quicklink__notify").click(function () {
    $(".notification-overlay").toggleClass("notification-overlay--active");
    notification_resize();
  });

  /**
   * Back button
   */
  var back_button = document.getElementById("breadcrumb-back-button");
  if (back_button && document.referrer && document.referrer.length) {
    // onlu use internal URLs
    if (document.referrer.indexOf("isannointiliitto.") >= 0) {
      back_button.setAttribute("href", document.referrer);
      back_button.addEventListener("click", function (e) {
        e.preventDefault();
        window.history.back();
      });
    }
  }

  // Jasenmaksulaskuri
  $(document).ready(function () {
    $("#jasenmaksulaskuri").isannointi_jasenmaksulaskuri();
  });

  // Hae isännöintiä
  $(document).ready(function () {
    if ($("#isannointi-company-search").length) {
      $("#isannointi-company-search").isannointi_hae_isannointia();
    }
  });

  // login menu
  $(document).ready(function () {
    var resizeTimer,
      $login_menu = $(".member-menu-toggle"),
      $members_menu = $("#members-menu");

    $($login_menu).on("click", function (e) {
      e.preventDefault();

      if ($("#members-mega-menu").hasClass("open")) {
        $("#members-mega-menu").removeClass("open");
      } else {
        $("#members-mega-menu").addClass("open");
        window.scrollTo(0, 0);
      }
    });
  });

  // product access denied
  $(document).ready(function () {
    if ($(".rcp-woocommerce-no-access").length) {
      $("body").addClass("woocommerce-access-denied");
    }
  });

  // search field focus
  $(".search-form__input").focus(function () {
    $(this).parents("form").addClass("focus");
  });
  $(".search-form__input").blur(function () {
    $(this).parents("form").removeClass("focus");
  });

  // inside button focus
  $(".inside-button input").focus(function () {
    $(this).parents(".inside-button").addClass("focus");
  });
  $(".inside-button input").blur(function () {
    $(this).parents(".inside-button").removeClass("focus");
  });

  // Footern navigation functionality
  $("#footer-menu .caret").click(function () {
    $(this).parents("li").toggleClass("open");
  });

  // Sidebar navigation functionality
  $(".sub-pages-navigation button").click(function () {
    var $li = $(this).parents("li");
    if (
      $li.hasClass("hidden") &&
      ($li.hasClass("current_page_item") ||
        $li.hasClass("current_page_ancestor"))
    ) {
      $li.addClass("open");
      $li.removeClass("hidden");
    } else if (
      $li.hasClass("current_page_item") ||
      $li.hasClass("current_page_ancestor")
    ) {
      $li.addClass("hidden");
      $li.removeClass("open");
    } else {
      $li.removeClass("hidden");
      $li.toggleClass("open");
    }
    //$(this).blur();
  });

  //Sidebar navigation open in mobile
  $(".js-open-submenu").click(function () {
    $(this).toggleClass("mobile-open");
    var parent = $(this).parents(".sub-pages__header");
    parent.siblings(".sub-pages-navigation").toggleClass("mobile-visible");
  });

  // Add external icon to external link in entry-content
  var comp = new RegExp(location.host);
  $(".entry-content")
    .find("a")
    .each(function () {
      if (
        !comp.test($(this).attr("href")) &&
        $(this).attr("href").indexOf("/") !== 0 &&
        $(this).attr("href").indexOf("#") !== 0 &&
        !$(this).hasClass("gform_anchor") &&
        $(this).attr("href") !== "" &&
        $(this).attr("href") &&
        $(this).attr("href") !== "#" &&
        !$(this).hasClass("no-external-icon")
      ) {
        var existing_svg = $(this).find(".icon-wrap");
        var image_inside = $(this).find("img");
        if (!existing_svg.length) {
          $(this).attr("target", "_blank");
          $(this).attr("rel", "noopener noreferrer");
          if (!image_inside.length) {
            $(this).append(
              $(
                '<span class="icon-wrap external-icon-wrap"><svg class="icon icon-external-link" aria-hidden="true" role="img"><use xlink:href="/wp-content/themes/isannointiliitto/dist/sprite/sprite.svg#icon-external-link"></use></svg></span>'
              )
            );
          }
        }
      }
    });

  // Remove empty hrefs from footer menu
  $('#footer-menu a[href="#"]').removeAttr("href").addClass("placeholder");

  // Filter AJAX
  function document_to_dom_object(data) {
    return $(
      $.trim(
        String(data)
          .replace(/<\!DOCTYPE[^>]*>/i, "")
          .replace(
            /<(html|head|body|title|meta|script)([\s\>])/gi,
            '<div class="document-$1"$2'
          )
          .replace(/<\/(html|head|body|title|meta|script)\>/gi, "</div>")
      )
    );
  }

  function ajax_setup_filter_view(url, new_title, is_new_state) {
    var $destination = $(".filter-area");
    $destination.addClass("loading");

    $.ajax({
      url: url,
      success: function (data, textStatus, jqXHR) {
        $("#filter-top-spinner").addClass("hide");

        // Prepare
        var $data = document_to_dom_object(data);
        var $dataBody = $data.find(".document-body:first");
        var $dataContent = $dataBody.find(".filter-area").filter(":first");
        var $social = $dataBody
          .find(".social-share-container")
          .filter(":first");
        var $numericNav = $dataBody
          .find(".numeric-navigation-container")
          .filter(":first");

        // Fetch the content
        var contentHtml = $dataContent.html() || $data.html();
        if (!contentHtml) {
          document.location.href = url;
          return false;
        }

        // Update the content
        $destination
          .html(contentHtml)
          .removeClass("loading"); /* you could fade in here if you'd like */
        if ($social) {
          $(".social-share-container").html($social.html());
        }
        if ($numericNav) {
          $(".numeric-navigation-container").html($numericNav.html());
        }

        // Change URL

        if (is_new_state === true) {
          // Go to new view

          // Update the title
          document.title = new_title;

          var new_url = url;
          var hostname = location.host;
          var history_url = new_url.replace(hostname, "");
          history_url = history_url.replace("http://", "");
          history_url = history_url.replace("https://", "");

          if (window.history.pushState) {
            window.history.pushState(history_url, new_title, history_url);
          }
        } else {
          // Go back
          // figure out which filter is active
          //var new_url = url;
          //var regex_filter = /filter=[a-z][-a-z0-9\._]*/g;
          //var match = regex_filter.exec(new_url);
          //$('.project-tags .active').blur().removeClass('active');
          //if(match === null) {
          //  $('#projects-all').addClass('active'); // no filter
          //} else {
          //  var active_filter_slug = match[0];
          //  active_filter_slug = active_filter_slug.replace("filter=", "");
          //  $('.project-tags a').each(function() {
          //    if($(this).attr('attr-filter') == active_filter_slug) {
          //      $(this).addClass('active');
          //    }
          //  });
          //}
        }
      },
      error: function (jqXHR, textStatus, errorThrown) {
        document.location.href = url;
        return false;
      },
    }); // end ajax
  }

  window.addEventListener("popstate", function (e) {
    var target = e.state;
    if (target) {
      ajax_setup_filter_view(target, "", false);
    }
  });

  $(".filter-tabs a").click(function (e) {
    e.preventDefault();
    $("#filter-top-spinner").removeClass("hide");
    var url = $(this).attr("href");
    var new_title = $(this).attr("attr-title");

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
    'event': 'categoryFilter',
    'categoryText':  $(this).text(),
    });


    $(".filter-tabs li").removeClass("active");
    $(this).parent("li").addClass("active");

    ajax_setup_filter_view(url, new_title, true);

    // Project page "Load more"
  });

  $("#page").on("click", "#events-load-more a", function (e) {
    e.preventDefault();
    var $destination = $(".event-grid").filter(":last");
    $("#events-load-more").addClass("loading");
    $("#events-bottom-spinner").removeClass("hide");

    var url = $(this).attr("href");
    $(this).blur();
    $.ajax({
      url: url,
      success: function (data, textStatus, jqXHR) {
        // Prepare
        var $data = document_to_dom_object(data);
        var $dataBody = $data.find(".document-body:first");
        var $content = $dataBody
          .find(".event-grid")
          .filter(":first")
          .addClass("entrance");

        // remove duplicates (second page shows all)

        $(".event-grid")
          .filter(":first")
          .find(".event-item")
          .each(function (i) {
            var id = $(this).attr("attr-id");
            $content.find(".featured-item").each(function (j) {
              if ($(this).attr("attr-id") === id && id > 0) {
                $(this).remove();
              }
            });
          });

        // insert more items
        $content.insertAfter($destination);
        setTimeout(function () {
          $(".event-grid").removeClass("entrance");
          $("#events-load-more").remove();
        }, 250);

        // manipulate load more button
        if ($dataBody.find("#events-load-more").length) {
          var new_href = $dataBody.find("#events-load-more a").attr("href");
          $("#events-load-more a").attr("href", new_href);
          $("#events-load-more").removeClass("loading");
        }

        $("#events-bottom-spinner").addClass("hide");
      },
      error: function (jqXHR, textStatus, errorThrown) {
        document.location.href = url;
        return false;
      },
    }); // end ajax
  });

  // Archive external posts
  if ($("#remote-posts-container").length) {
    if (!$("#remote-posts-container").hasClass("ready")) {
      var $container = $("#remote-posts-container");
      var taxonomy = $container.attr("attr-taxonomy");
      var term = $container.attr("attr-term");
      var search = $container.attr("attr-search");
      var fetch_url =
        "/wp-content/plugins/isannointiliitto/inc/endpoints/remote-posts-in-same-category.php";
      if (taxonomy) {
        fetch_url += "?taxonomy=" + taxonomy + "&term=" + term;
      } else {
        fetch_url += "?term=" + term;
      }
      $.ajax({
        url: fetch_url,
      }).done(function (html) {
        if (html.length > 1) {
          $container.find(".loader").addClass("hide");
          $container.append(html);
        } else {
          $container.addClass("hide");
        }
      });
    }
  }

  // Landingpage external posts
  if ($("#remote-posts-container-landingpage").length) {
    var $container = $("#remote-posts-container-landingpage");
    var taxonomy = $container.attr("attr-taxonomy");
    var term = $container.attr("attr-term");
    var search = $container.attr("attr-search");
    var source = $container.attr("attr-source");
    var fetch_url =
      "/wp-content/plugins/isannointiliitto/inc/endpoints/remote-posts-landingpage.php";
    if (taxonomy) {
      fetch_url +=
        "?taxonomy=" + taxonomy + "&term=" + term + "&source=" + source;
    } else {
      fetch_url += "?term=" + term + "&source=" + source;
    }
    $.ajax({
      url: fetch_url,
    }).done(function (html) {
      $container.find(".loader").addClass("hide");
      $container.append(html);
    });
  }

  // Mappi kt_embed
  if ($("#remote-posts-container-kt-embed").length) {
    var $container = $("#remote-posts-container-kt-embed");
    var slugs = $container.attr("attr-slugs");
    var fetch_url =
      "/wp-content/plugins/isannointiliitto/inc/endpoints/remote-posts-lisavirtaa.php";
    if (slugs) {
      fetch_url += "?slug=" + slugs;
    } else {
    }
    $.ajax({
      url: fetch_url,
    }).done(function (html) {
      $container.find(".loader").addClass("hide");
      $container.append(html);
    });
  }

  // Newsroom external posts
  if ($("#remote-posts-container-newsroom").length) {
    var $container = $("#remote-posts-container-newsroom");
    var taxonomy = $container.attr("attr-taxonomy");
    var term = $container.attr("attr-term");
    var search = $container.attr("attr-search");
    var source = $container.attr("attr-source");
    var allposts = $container.attr("attr-allposts");
    var fetch_url =
      "/wp-content/plugins/isannointiliitto/inc/endpoints/remote-posts-newsroom.php";
    if (taxonomy) {
      fetch_url +=
        "?taxonomy=" + taxonomy + "&term=" + term + "&source=" + source;
    } else {
      fetch_url +=
        "?term=" + term + "&source=" + source + "&allposts=" + allposts;
    }
    $.ajax({
      url: fetch_url,
    }).done(function (html) {
      $container.find(".loader").addClass("hide");
      $container.append(html);
    });
  }
  var openBtn = $(".feedback-btn");
  var feedbackform = $("#feedback-wrap form");

  feedbackform.hide();
  openBtn.on("click", function (e) {
    e.preventDefault();
    feedbackform.slideToggle();
  });

  var $btns = $(".related-external .btn").click(function () {
    $(".remote-posts-newsroom > a").fadeOut(100);
    if (this.id === "all") {
      //$('.remote-posts-newsroom > a').fadeIn(100);
      $(".kotitalo:lt(2)").fadeIn(100);
      $(".lisavirtaa:lt(2)").fadeIn(100);
      $(".pihaparlamentti:lt(2)").fadeIn(100);
      $(".remote-posts-newsroom").addClass("all").removeClass("single");
    } else {
      var $el = $("." + this.id).fadeIn(100);
      $(".remote-posts-newsroom").addClass("single").removeClass("all");
      $(".remote-posts-newsroom > a").not($el).fadeOut(100);
    }
    $btns.removeClass("active");
    $(this).addClass("active");
  });

  function supports_history_api() {
    return !!(window.history && history.pushState);
  }

  // Shortcode: ISL-accordion
  $(".isl-accordion-button").click(function (e) {
    e.preventDefault();
    $(this).parents(".isl-accordion").toggleClass("accordion-open");
  });

  // $('.member-search-feedback-button').click(function() {
  //   $('.member-search-feedback-form').addClass('show');
  // });
  $(document).on("click", ".member-search-feedback-button", function () {
    $(".member-search-feedback-form").addClass("show");
  });

  // $('.member-search-feedback-form-close').click(function() {
  //   $('.member-search-feedback-form').removeClass('show');
  // });
  $(document).on("click", ".member-search-feedback-form-close", function () {
    $(".member-search-feedback-form").removeClass("show");
  });

  $(".isannointi-member-list").click(function (e) {
    e.preventDefault();
    var $form = $("#member-search-form");
    var url = $(this).attr("href");
    var class_name = url.substr(url.indexOf("?lista=") + 7);

    $form.attr("data-default-order", $(this).attr("data-default-order"));
    if ($(this).attr("data-default-order") == "date") {
      $("#member-search-sort-abc").text("Näytä aakkosjärjestyksessä");
    } else {
      $("#member-search-sort-abc").text("Näytä aikajärjestyksessä");
    }
    $form.removeClass();
    $form.addClass("form-active");
    isl_member_ajax_to(url);
  });

  $(document).ready(function () {
    setTimeout(function () {
      $("#all").trigger("click");
    }, 2000);
  });

  // dismiss order
  $("#cart-bar-dismiss-order").click(function (e) {
    e.preventDefault();
    var url = $(this).attr("href");
    $.ajax({
      url: url,
      success: function (data, textStatus, jqXHR) {},
    });
    $("#cart-bar").addClass("hide");
  });

  // select active tab
  $(document).ready(function () {
    if (window.location.hash) {
      var hash = window.location.hash;
      if (hash.indexOf("tab-") !== -1) {
        $(hash + " a").trigger("click");
      }
    }
  });

  // jasenpalvelu tags
  $(".js-member-search__tags__button").click(function (e) {
    $(e.currentTarget)
      .parents(".js-member-search__tags")
      .toggleClass("is-open");
  });

  // hotfix for main column image quality
  $(".pb-section .pb-section__column:first .teaser-post__thumbnail img").attr(
    "sizes",
    "656px"
  );

  // helper function to remove URL parameter
  function removeURLParameter(url, parameter) {
    var urlparts = url.split("?");
    if (urlparts.length >= 2) {
      var prefix = encodeURIComponent(parameter) + "=";
      var pars = urlparts[1].split(/[&;]/g);
      for (var i = pars.length; i-- > 0; ) {
        if (pars[i].lastIndexOf(prefix, 0) !== -1) {
          pars.splice(i, 1);
        }
      }
      url = urlparts[0] + (pars.length > 0 ? "?" + pars.join("&") : "");
      return url;
    } else {
      return url;
    }
  }

  // event signup
  var event_signup_button = document.querySelector(".js-event-signup-button");
  if (event_signup_button) {
    event_signup_button.addEventListener("click", function () {
      var modal = document.querySelector("#isl-event-form");
      if (modal) {
        modal.classList.add("notification-overlay--active");
      }
    });
  }

  /**
   * Video
   */

  // hero video
  var hero_video = document.getElementById("hero-video");

  if (hero_video) {
    hero_video.addEventListener("canplaythrough", function () {
      this.play();
    });
  }

  var slides = 7;

  if ($(".service-wrapper").children().length < 7) {
    slides = 5;
  } else {
    slides = 5;
  }

  $(".member-service-boxes .service-wrapper").slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: slides,
    slidesToScroll: 3,
    centerMode: true,
    autoplay: true,
    autoplaySpeed: 5000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          centerMode: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          centerMode: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          centerMode: false,
        },
      },
    ],
  });

  // mappi themes
  $(".members-featured-content .featured-content").slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          dots: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
        },
      },
    ],
  });

  // theme pre-footer
  $(".theme-pre-footer .content").slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 720,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          dots: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
        },
      },
    ],
  });

  /**
   * Search by title
   */
  var search_forms = document.querySelectorAll(".js-search-form-autocomplete");
  if (search_forms.length) {
    for (var i = 0; i < search_forms.length; ++i) {
      var search_form = search_forms[i];
      var name_input = search_forms[i].querySelector(".search-form__input");
      var name_amount = search_forms[i].querySelector(".search-form__reset");
      if (name_input) {
        var ajax;
        var previous_length = 0;

        search_forms[i].addEventListener("keyup", function (e) {
          var name_input = e.target;
          var $search_form = $(e.target).parents("form");

          if (name_input.value.length >= 3) {
            // abort previous call
            if (
              typeof ajax !== "undefined" &&
              typeof ajax.abort !== "undefined"
            ) {
              ajax.abort();
            }

            $search_form.addClass("search-form--loading");

            ajax = new XMLHttpRequest();
            ajax.open(
              "GET",
              "/?s=" + encodeURI(name_input.value) + "&type=autocomplete",
              true
            );

            // track quick search to analytics
            // if (typeof ga !== "undefined") {
            //   // virtual pageview
            //   ga("send", {
            //     hitType: "pageview",
            //     location:
            //       "https://www.isannointiliitto.fi/?s=" +
            //       encodeURI(name_input.value) +
            //       "&s_type=quicksearch",
            //   });
            // }

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
            'event': 'search',
            'searchTerm': name_input.value,
            'searchLocation': 'mappi',
            });

            ajax.onload = function () {
              var data = JSON.parse(ajax.responseText);

              if (data.posts.length) {
                // hide previously added
                var previous_modals = document.querySelectorAll(
                  ".js-search-autocomplete"
                );
                for (var i = 0; i < previous_modals.length; i++) {
                  previous_modals[i].remove();
                }

                var html = "";
                html +=
                  '<div style="top:' +
                  ($search_form.outerHeight() + 2) +
                  'px" class="js-search-autocomplete search-autocomplete">';
                html += "<ul>";
                for (var i = 0; i < data.posts.length; i++) {
                  html +=
                    '<li><a href="' +
                    data.posts[i].url +
                    '">' +
                    data.posts[i].title +
                    "</a></li>";
                }
                html += "</ul>";
                if (data.search.has_more) {
                  html +=
                    '<div class="search-autocomplete__more"><a href="' +
                    data.search.url +
                    '">' +
                    data.search.title +
                    "</a></div>";
                }
                html += "</div>";

                $(html).insertAfter($(e.target));
              }

              // if (nmb === 0) {
              //   response = 'Ei tuloksia';
              // } else if (nmb === 1){
              //   response = nmb + ' tulos';
              // } else {
              //   response = nmb + ' tulosta';
              // }
              // name_amount.classList.remove('member-search-amount--loading');
              // name_amount.classList.add('member-search-amount--active');
              // name_amount.textContent = response;

              $search_form.removeClass("search-form--loading");
              $search_form.addClass("search-form--autocomplete");
            };
            ajax.send();
          } else {
            // abort previous call
            if (
              typeof ajax !== "undefined" &&
              typeof ajax.abort !== "undefined"
            ) {
              ajax.abort();
            }

            $(".js-search-autocomplete").remove();
            $search_form.removeClass("search-form--loading");
            $search_form.removeClass("search-form--autocomplete");
          }
        });
      }
    }
  }

  $("#container").on("click", ".search-form__close", function (e) {
    e.preventDefault();
    var $form = $(e.currentTarget).parents("form");
    $(".js-search-autocomplete").remove();
    $form.removeClass("search-form--loading");
    $form.removeClass("search-form--autocomplete");
    console.log($form.find("search-form__input"));
    $form.find("search-form__input").focus();
  });
})(jQuery);

/**
 * Responsive tables
 */
var responsive_tables_in_content = function () {
  var tables = document.querySelectorAll(
    ".entry-content table, .single-event .content-area table, .flexible-wrapper table"
  );
  if (tables.length) {
    for (var i = 0; i < tables.length; i++) {
      // add modifier class to affected table
      tables[i].classList.add("responsive-table");

      // create new wrapper
      var wrapper = document.createElement("div");

      // remove inline styles (often added by Excel)
      var tds = tables[i].querySelectorAll("td");
      if (tds.length) {
        for (var j = 0; j < tds.length; j++) {
          tds[j].removeAttribute("width");
          tds[j].removeAttribute("style");
        }
      }

      // take all classes from table
      wrapper.setAttribute("class", tables[i].getAttribute("class"));

      // reset table classes
      tables[i].removeAttribute("class");

      // wrap the table
      tables[i].parentNode.insertBefore(wrapper, tables[i]);
      wrapper.appendChild(tables[i]);
    }
  }
};
responsive_tables_in_content();
